/**
 * Created by 王石磊 on 2018/3/29.
 */
import Vue from 'vue'
var utils = {
// 判断是否是手机端
  /*isMobile: function () {
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag
  },*/
  goLoginPage: function (_this) {
    //接收1个参数。_this：指向vue实例
    let path = _this.$route.fullPath
    localStorage.setItem('historyPath', path);
    _this.$router.push({path: '/login'});
  },
  // 防抖
	debounce(fn, delay = 300) {
		return function(...args) {
			clearTimeout(fn.id)
			fn.id = setTimeout(() => {
				fn.apply(this, args)
			}, delay)
		}
	},
	// 节流
	throttle(fn, inteval = 300) {
		return function(...args) {
			if (!fn.id) {
				fn.id = setTimeout(() => {
					fn.apply(this, args)
					fn.id = null
				}, inteval)
			}
		}
	}
}
Vue.prototype.$util = utils
export default utils



// WEBPACK FOOTER //
// ./src/util/utils.js